export default __webpack_public_path__ + "static/generous_team-min-a6564685c529ed82c0ee800359a73b3f.png";